import { Helmet } from "react-helmet-async";
import { useCallback, useContext, useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  MenuItem,
  Container,
  Typography,
  IconButton,
  Box,
  TextField,
  Grid,
  Select,
  CircularProgress,
  Backdrop,
  Tooltip,
} from "@mui/material";
// components
import Iconify from "../components/iconify";

import { useLocation, useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import SunEditor from "suneditor-react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { baseUrl, categoryUrl, postUrl } from "src/api";
import Context from "src/context/context";
import { notifyError } from "src/utils/Toast";

import InfoIcon from "@mui/icons-material/Info";
import { ToastContainer } from "react-toastify";
import { compressToBase64 } from 'lz-string';
// ----------------------------------------------------------------------

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function PostStorePage() {
  const navigate = useNavigate();
  const { token } = useContext(Context);
  const location = useLocation();
  const [expanded, setExpanded] = useState("panel1");
  const handleChangeAccordian = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [loader, setLoader] = useState(false);

  const [, setStoredHeader] = useState(null);
  const [, setStoredTag] = useState(null);
  const [, setStoredFilter] = useState(null);
  const [storedFeatureImage, setStoredFeaturedImage] = useState(null);

  const [categories, setCategories] = useState([]);
  const defaultValues = {
    catId: null,
    headerId: null,
    filterId: null,

    title: location?.state?.row?.title ? location?.state?.row?.title : null,
    slug: location?.state?.row?.slug ? location?.state?.row?.slug : null,
    meta_des: location?.state?.row?.meta_des
      ? location?.state?.row?.meta_des
      : null,
    description: location?.state?.row?.title
      ? location?.state?.row?.description
      : null,
    featuredImage: null,

    previewTitle1: location?.state?.row?.preview_title_1
      ? location?.state?.row?.preview_title_1
      : null,
    previewTitle2: location?.state?.row?.preview_title_2
      ? location?.state?.row?.preview_title_2
      : null,
    previewTitle3: location?.state?.row?.preview_title_3
      ? location?.state?.row?.preview_title_3
      : null,
    previewTitle4: location?.state?.row?.preview_title_4
      ? location?.state?.row?.preview_title_4
      : null,
    previewTitle5: location?.state?.row?.preview_title_5
      ? location?.state?.row?.preview_title_5
      : null,
    previewTitle6: location?.state?.row?.preview_title_6
      ? location?.state?.row?.preview_title_6
      : null,
    previewTitle7: location?.state?.row?.preview_title_7
      ? location?.state?.row?.preview_title_7
      : null,
    previewTitle8: location?.state?.row?.preview_title_8
      ? location?.state?.row?.preview_title_8
      : null,
    previewTitle9: location?.state?.row?.preview_title_9
      ? location?.state?.row?.preview_title_9
      : null,
    previewTitle10: location?.state?.row?.preview_title_10
      ? location?.state?.row?.preview_title_10
      : null,
    previewTitle11: location?.state?.row?.preview_title_11
      ? location?.state?.row?.preview_title_11
      : null,
    previewTitle12: location?.state?.row?.preview_title_12
      ? location?.state?.row?.preview_title_12
      : null,

    key_f_1: location?.state?.row?.key_f_1
      ? location?.state?.row?.key_f_1
      : null,
    key_f_2: location?.state?.row?.key_f_2
      ? location?.state?.row?.key_f_2
      : null,
    key_f_3: location?.state?.row?.key_f_3
      ? location?.state?.row?.key_f_3
      : null,
    key_f_4: location?.state?.row?.key_f_4
      ? location?.state?.row?.key_f_4
      : null,
    key_f_5: location?.state?.row?.key_f_5
      ? location?.state?.row?.key_f_5
      : null,
    key_f_6: location?.state?.row?.key_f_6
      ? location?.state?.row?.key_f_6
      : null,
    key_f_7: location?.state?.row?.key_f_7
      ? location?.state?.row?.key_f_7
      : null,
    key_f_8: location?.state?.row?.key_f_8
      ? location?.state?.row?.key_f_8
      : null,

    previewImage1: null,
    previewImage2: null,
    previewImage3: null,
    previewImage4: null,
    previewImage5: null,
    previewImage6: null,
    previewImage7: null,
    previewImage8: null,
    previewImage9: null,
    previewImage10: null,
    previewImage11: null,
    previewImage12: null,

    fileUrl: location?.state?.row?.file_url
      ? location?.state?.row?.file_url
      : null,
    previewUrl: location?.state?.row?.preview_url
      ? location?.state?.row?.preview_url
      : null,
    readingTime: location?.state?.row?.read_time
      ? location?.state?.row?.read_time
      : null,
    gifFile: null,

    authorName: location?.state?.row?.author_name
      ? location?.state?.row?.author_name
      : null,
    authorUrl: location?.state?.row?.author_url
      ? location?.state?.row?.author_url
      : null,
    other: location?.state?.row?.others ? location?.state?.row?.others : null,
  };
  const methods = useForm({ defaultValues });
  const { watch, setValue } = methods;
  const values = watch();

  // get all  categories
  const allCategories = useCallback(() => {
    let config = {
      method: "get",
      url: categoryUrl,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setCategories(response?.data?.categorys);
        if (location?.state != null && response?.data?.categorys.length > 0) {
          response?.data?.categorys.forEach((element) => {
            if (location?.state?.row?.header_id === element.id) {
              setStoredHeader(element.category_name);
              setValue("headerId", element.id);
            }
            if (location?.state?.row?.cat_id === element.id) {
              setStoredTag(element.category_name);
              setValue("catId", element.id);
            }
            if (location?.state?.row?.filter_id === element.id) {
              setStoredFilter(element.category_name);
              setValue("filterId", element.id);
            }
          });
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  },[location?.state, setValue, token]);

  //call categories
  useEffect(() => {
    allCategories();
  }, [allCategories]);

  //  udate loaction fileds
  useEffect(() => {
    if (location?.state !== null) {
      setStoredFeaturedImage(location?.state?.row?.image);
    }
  }, [location?.state]);


  const handleChangePosition = (event, position) => {
    setValue("catId", event.target.value);
  };

  // handle editor change
  const handleEditorChange = (content) => {
    setValue("description", content);
  };

  // const handle previewTitle
  const handlePreviewTitle = (e, num) => {
    if (num === 1) {
      setValue("previewTitle1", e.target.value);
    }
    if (num === 2) {
      setValue("previewTitle2", e.target.value);
    }
    if (num === 3) {
      setValue("previewTitle3", e.target.value);
    }
    if (num === 4) {
      setValue("previewTitle4", e.target.value);
    }
    if (num === 5) {
      setValue("previewTitle5", e.target.value);
    }
    if (num === 6) {
      setValue("previewTitle6", e.target.value);
    }
    if (num === 7) {
      setValue("previewTitle7", e.target.value);
    }
    if (num === 8) {
      setValue("previewTitle8", e.target.value);
    }
    if (num === 9) {
      setValue("previewTitle9", e.target.value);
    }
    if (num === 10) {
      setValue("previewTitle10", e.target.value);
    }
    if (num === 11) {
      setValue("previewTitle11", e.target.value);
    }
    if (num === 12) {
      setValue("previewTitle12", e.target.value);
    }
  };

  // const handle previewImage
  const handlePreviewImage = (e, num) => {
    if (num === 1) {
      setValue("previewImage1", e.target.files[0]);
    }
    if (num === 2) {
      setValue("previewImage2", e.target.files[0]);
    }
    if (num === 3) {
      setValue("previewImage3", e.target.files[0]);
    }
    if (num === 4) {
      setValue("previewImage4", e.target.files[0]);
    }
    if (num === 5) {
      setValue("previewImage5", e.target.files[0]);
    }
    if (num === 6) {
      setValue("previewImage6", e.target.files[0]);
    }
    if (num === 7) {
      setValue("previewImage7", e.target.files[0]);
    }
    if (num === 8) {
      setValue("previewImage8", e.target.files[0]);
    }
    if (num === 9) {
      setValue("previewImage9", e.target.files[0]);
    }
    if (num === 10) {
      setValue("previewImage10", e.target.files[0]);
    }
    if (num === 11) {
      setValue("previewImage11", e.target.files[0]);
    }
    if (num === 12) {
      setValue("previewImage12", e.target.files[0]);
    }
  };

  // store post
  // const handleStorePost = () => {
  //   setLoader(true);
  //   const compressedDescription = compressToBase64(values.description);  
  //   // Prepare data as a JSON object
  //   const data = {
  //     cat_id: values.catId,
  //     header_id: values.catId,
  //     filter_id: values.catId,
  //     read_time: values.readingTime,
  //     image: values.featuredImage,
  //     title: values.title,
  //     slug: values.slug,
  //     meta_des: values.meta_des,
  //     // description: values.description,
  //     description: compressedDescription,
  //     file_url: values.fileUrl,
  //     preview_url: values.previewUrl,
  //     gif_file: values.gifFile,
  //     author_name: values.authorName,
  //     author_url: values.authorUrl,
  //     others: values.other || null, // Only include if 'other' is provided
  //   };
  
  //   // Dynamically add preview titles (up to 12)
  //   for (let i = 1; i <= 12; i++) {
  //     const previewTitle = values[`previewTitle${i}`];
  //     if (previewTitle) data[`preview_title_${i}`] = previewTitle;
  //   }
  
  //   // Dynamically add key fields (up to 8)
  //   for (let i = 1; i <= 8; i++) {
  //     const keyField = values[`key_f_${i}`];
  //     if (keyField) data[`key_f_${i}`] = keyField;
  //   }
  
  //   // Dynamically add preview images (up to 12)
  //   for (let i = 1; i <= 12; i++) {
  //     const previewImage = values[`previewImage${i}`];
  //     if (previewImage) data[`preview_image_${i}`] = previewImage;
  //   }
  
  //   // Determine URL based on location state
  //   const url = location?.state ? `${postUrl}/${location.state.row.id}` : postUrl;
  
  //   const config = {
  //     method: "post",
  //     url,
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json", // Content type is application/json
  //     },
  //     data: JSON.stringify(data), // Ensure data is properly stringified
  //     timeout: 60000, 
  //   };
  
  //   axios
  //     .request(config)
  //     .then((response) => {
  //       setLoader(false);
  //       if (response?.data?.success) {
  //         navigate("/dashboard/posts");
  //       } else {
  //         // Handle failure response gracefully
  //         notifyError(response?.data?.message);
  //         if (Array.isArray(response?.data?.message)) {
  //           response?.data?.message.forEach((message) => {
  //             notifyError(message); // Display individual errors
  //           });
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       setLoader(false);
  //       const errorMessage = error?.response?.data?.message || "Something went wrong!";
  //       notifyError(errorMessage); // Gracefully handle the error
  //     });
  // };

    // store post
    const handleStorePost = () => {
      const compressedDescription = compressToBase64(values.description);  
      setLoader(true);
      let data = new FormData();
      data.append("cat_id", values.catId);
      data.append("header_id", values.headerId);
      data.append("filter_id", values.filterId);
      data.append("read_time", values.readingTime);
      data.append("image", values.featuredImage);
      data.append("title", values.title);
      data.append("slug", values.slug);
      data.append("meta_des", values.meta_des);
      data.append("description", compressedDescription);
  
      data.append("preview_title_1", values.previewTitle1);
      data.append("preview_title_2", values.previewTitle2);
      data.append("preview_title_3", values.previewTitle3);
      data.append("preview_title_4", values.previewTitle4);
      data.append("preview_title_5", values.previewTitle5);
      data.append("preview_title_6", values.previewTitle6);
      data.append("preview_title_7", values.previewTitle7);
      data.append("preview_title_8", values.previewTitle8);
      data.append("preview_title_9", values.previewTitle9);
      data.append("preview_title_10", values.previewTitle10);
      data.append("preview_title_11", values.previewTitle11);
      data.append("preview_title_12", values.previewTitle12);
  
      data.append("key_f_1", values.key_f_1);
      data.append("key_f_2", values.key_f_2);
      data.append("key_f_3", values.key_f_3);
      data.append("key_f_4", values.key_f_4);
      data.append("key_f_5", values.key_f_5);
      data.append("key_f_6", values.key_f_6);
      data.append("key_f_7", values.key_f_7);
      data.append("key_f_8", values.key_f_8);
  
      data.append("preview_image_1", values.previewImage1);
      data.append("preview_image_2", values.previewImage2);
      data.append("preview_image_3", values.previewImage3);
      data.append("preview_image_4", values.previewImage4);
      data.append("preview_image_5", values.previewImage5);
      data.append("preview_image_6", values.previewImage6);
      data.append("preview_image_7", values.previewImage7);
      data.append("preview_image_8", values.previewImage8);
      data.append("preview_image_9", values.previewImage9);
      data.append("preview_image_10", values.previewImage10);
      data.append("preview_image_11", values.previewImage11);
      data.append("preview_image_12", values.previewImage12);
  
      data.append("file_url", values.fileUrl);
      data.append("preview_url", values.previewUrl);
      data.append("gif_file", values.gifFile);
      data.append("author_name", values.authorName);
      data.append("author_url", values.authorUrl);
      if (values.other) {
        data.append("others", values.other);
      }
  
      var config;
  
      if (location?.state !== null) {
        config = {
          method: "post",
          url: `${postUrl}/${location?.state?.row?.id}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: data,
        };
      } else {
        config = {
          method: "post",
          url: postUrl,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data: data,
        };
      }
  
      axios
        .request(config)
        .then((response) => {
          if (response?.data?.success === true) {
            setLoader(false);
            navigate("/dashboard/posts");
          }
          if (response?.data?.success === false) {
            setLoader(false);
            response?.data?.message.forEach((element) => {
              notifyError(element);
            });
          }
        })
        .catch((error) => {
          setLoader(false);
          if (error?.response) {
            notifyError(error?.response?.data?.message);
          } else {
            notifyError("Something went wrong!. ");
          }
        });
    };
  
  
  
  // handle slug
  const handleSlug = (e) => {
    const inputValue = e.target.value;
    setValue("title", inputValue);
    const slug = inputValue.toLowerCase().replace(/[^\w-]+/g, "-");
    setValue("slug", slug);
  };



  return (
    <>
      <Helmet>
        <title> Post | Store </title>
      </Helmet>

      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
          // onClick={handleLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      <Container maxWidth="xl">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Post Store
          </Typography>
          {location?.state !== null && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={(e) => handleStorePost()}
            >
              Update Post
            </Button>
          )}
        </Stack>

        <Grid container spacing={3}>
          <Grid item xs={10} md={10}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChangeAccordian("panel1")}
                >
                  <AccordionSummary
                    aria-controls="panel1d-content"
                    id="panel1d-header"
                  >
                    <Typography>
                      #1 Header,Tags & Filter (all required *)
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={3}>
                      <Grid item xs={4} md={4}>
                        <Card sx={{ p: 3 }}>
                          <Stack spacing={3}>
                            <FormControl>
                              <InputLabel id="demo-simple-select-label">
                                Select From Header
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values.catId}
                                label="Select From Header"
                                onChange={(e) =>
                                  handleChangePosition(e, "header")
                                }
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              >
                                {categories &&
                                  categories.map((cat, i) => {
                                    if (cat.category_position === "header") {
                                      return (
                                        <MenuItem value={cat.id}>
                                          {cat.category_name}
                                        </MenuItem>
                                      );
                                    }
                                  })}
                              </Select>
                            </FormControl>
                          </Stack>
                        </Card>
                      </Grid>

                      <Grid item xs={4} md={4}>
                        <Card sx={{ p: 3 }}>
                          <Stack spacing={3}>
                            <FormControl>
                              <InputLabel id="demo-simple-select-label">
                                Select From Tag
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values.catId}
                                label="Select From Tag"
                                onChange={(e) => handleChangePosition(e, "tag")}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              >
                                {categories &&
                                  categories.map((cat, i) => {
                                    if (cat.category_position === "tag") {
                                      return (
                                        <MenuItem value={cat.id}>
                                          {cat.category_name}
                                        </MenuItem>
                                      );
                                    }
                                  })}
                              </Select>
                            </FormControl>
                           
                          </Stack>
                        </Card>
                      </Grid>

                      <Grid item xs={4} md={4}>
                        <Card sx={{ p: 3 }}>
                          <Stack spacing={3}>
                            <FormControl>
                              <InputLabel id="demo-simple-select-label">
                                Select From Filter
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={values.catId}
                                label="Select From Filter"
                                onChange={(e) =>
                                  handleChangePosition(e, "filter")
                                }
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                              >
                                {categories &&
                                  categories.map((cat, i) => {
                                    if (cat.category_position === "filter") {
                                      return (
                                        <MenuItem value={cat.id}>
                                          {cat.category_name}
                                        </MenuItem>
                                      );
                                    }
                                  })}
                              </Select>
                            </FormControl>
                            
                          </Stack>
                        </Card>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChangeAccordian("panel2")}
                >
                  <AccordionSummary
                    aria-controls="panel2d-content"
                    id="panel2d-header"
                  >
                    <Typography>
                      #2 Title,Reading Time, Featurd Image Meta Des &
                      Description
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={12}>
                        <Card sx={{ p: 3 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="title"
                              label="Title"
                              onChange={(e) => handleSlug(e)}
                              value={values.title}
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                            />
                            <TextField
                              name="slug"
                              label="Slug"
                              value={values.slug}
                              onChange={(e) => setValue("slug", e.target.value)}
                              slotProps={{
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                            />
                            <TextField
                              type="number"
                              name="readingTime"
                              label="Reading Time(0-10)"
                              onChange={(e) =>
                                setValue("readingTime", e.target.value)
                              }
                              value={values.readingTime}
                            />
                            <TextField
                              name="meta_des"
                              variant="outlined"
                              fullWidth
                              multiline
                              label="Meta Description"
                              minRows={3}
                              size="small"
                              value={values.meta_des}
                              onChange={(e) =>
                                setValue("meta_des", e.target.value)
                              }
                            />
                            <Box sx={{ mt: 2 }}>
                              <SunEditor
                                id="details"
                                name="description"
                                setContents={values.description}
                                showToolbar={true}
                                setDefaultStyle="height: 400px"
                                onChange={handleEditorChange}
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                      "paragraphStyle",
                                      "blockquote",
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "fontColor",
                                      "hiliteColor",
                                      "textStyle",
                                      "removeFormat",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "lineHeight",
                                      "table",
                                      "link",
                                      "image",
                                      "video",
                                      "audio",
                                      "imageGallery",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                      "template",
                                    ],
                                  ],
                                }}
                              />
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Stack spacing={2}>
                          <Card sx={{ p: 2 }}>
                            <Box sx={{ mb: 2, mt: 2, ml: 5, minHeight: 165 }}>
                              <Button
                                variant="contained"
                                component="label"
                                sx={{ mt: 8, ml: 3 }}
                              >
                                Upload File
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    setValue("featuredImage", e.target.files[0])
                                  }
                                  hidden
                                />
                              </Button>
                            </Box>
                          </Card>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Stack spacing={2}>
                          <Card sx={{ p: 2 }}>
                            <Box sx={{ mb: 2, mt: 2, minHeight: 165 }}>
                              {values.featuredImage !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.featuredImage
                                  )}
                                  alt=""
                                />
                              )}
                            </Box>
                          </Card>
                        </Stack>
                      </Grid>
                      {storedFeatureImage != null && (
                        <Grid item xs={12} md={4}>
                          <Stack spacing={2}>
                            <Card sx={{ p: 2 }}>
                              <Box sx={{ mb: 2, mt: 2, minHeight: 150 }}>
                                <img
                                  src={`${baseUrl}/storage/${storedFeatureImage}`}
                                  alt=""
                                />
                              </Box>
                              <Box
                                sx={{ fontSize: 10 }}
                                display="flex"
                                justifyContent="center"
                              >
                                Stored Feature Image
                              </Box>
                            </Card>
                          </Stack>
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChangeAccordian("panel3")}
                >
                  <AccordionSummary
                    aria-controls="panel2d-content"
                    id="panel2d-header"
                  >
                    <Typography>#3 Key Features</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={12}>
                        <Card sx={{ p: 3 }}>
                          <Stack spacing={3}>
                            <TextField
                              type="text"
                              name="key_f_1"
                              label="Feature 1"
                              onChange={(e) =>
                                setValue("key_f_1", e.target.value)
                              }
                              value={values.key_f_1}
                            />
                            <TextField
                              type="text"
                              name="key_f_2"
                              label="Feature 2"
                              onChange={(e) =>
                                setValue("key_f_2", e.target.value)
                              }
                              value={values.key_f_2}
                            />
                            <TextField
                              type="text"
                              name="key_f_3"
                              label="Feature 3"
                              onChange={(e) =>
                                setValue("key_f_3", e.target.value)
                              }
                              value={values.key_f_3}
                            />
                            <TextField
                              type="text"
                              name="key_f_4"
                              label="Feature 4"
                              onChange={(e) =>
                                setValue("key_f_4", e.target.value)
                              }
                              value={values.key_f_4}
                            />
                            <TextField
                              type="text"
                              name="key_f_5"
                              label="Feature 5"
                              onChange={(e) =>
                                setValue("key_f_5", e.target.value)
                              }
                              value={values.key_f_5}
                            />
                            <TextField
                              type="text"
                              name="key_f_6"
                              label="Feature 6"
                              onChange={(e) =>
                                setValue("key_f_6", e.target.value)
                              }
                              value={values.key_f_6}
                            />
                            <TextField
                              type="text"
                              name="key_f_7"
                              label="Feature 7"
                              onChange={(e) =>
                                setValue("key_f_7", e.target.value)
                              }
                              value={values.key_f_7}
                            />
                            <TextField
                              type="text"
                              name="key_f_8"
                              label="Feature 8"
                              onChange={(e) =>
                                setValue("key_f_8", e.target.value)
                              }
                              value={values.key_f_8}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChangeAccordian("panel4")}
                >
                  <AccordionSummary
                    aria-controls="panel3d-content"
                    id="panel3d-header"
                  >
                    <Typography>#4 ScreenShots</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* secreenshot -1 */}
                    <Grid container spacing={1}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleOne"
                              label="Screenshot Title 1"
                              onChange={(e) => handlePreviewTitle(e, 1)}
                              value={values.previewTitle1}
                            />
                          </Stack>
                        </Card>
                      </Grid>

                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 1)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage1 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage1
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_1 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_1}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -2 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleTwo"
                              label="Screenshot Title 2"
                              onChange={(e) => handlePreviewTitle(e, 2)}
                              value={values.previewTitle2}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 2)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage2 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage2
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_2 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_2}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -3 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleThree"
                              label="Screenshot Title 3"
                              onChange={(e) => handlePreviewTitle(e, 3)}
                              value={values.previewTitle3}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 3)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage3 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage3
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_3 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_3}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -4 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleFour"
                              label="Screenshot Title 4"
                              onChange={(e) => handlePreviewTitle(e, 4)}
                              value={values.previewTitle4}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 4)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage4 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage4
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_4 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_4}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -5 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleFive"
                              label="Screenshot Title 5"
                              onChange={(e) => handlePreviewTitle(e, 5)}
                              value={values.previewTitle5}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 5)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage5 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage5
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_5 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_5}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -6 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleSix"
                              label="Screenshot Title 6"
                              onChange={(e) => handlePreviewTitle(e, 6)}
                              value={values.previewTitle6}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 6)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage6 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage6
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_6 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_6}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -7 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleSeven"
                              label="Screenshot Title 7"
                              onChange={(e) => handlePreviewTitle(e, 7)}
                              value={values.previewTitle7}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 7)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage7 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage7
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_7 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_7}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -8 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleEight"
                              label="Screenshot Title 8"
                              onChange={(e) => handlePreviewTitle(e, 8)}
                              value={values.previewTitle8}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 8)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage8 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage8
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_8 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_8}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -9 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleNine"
                              label="Screenshot Title 9"
                              onChange={(e) => handlePreviewTitle(e, 9)}
                              value={values.previewTitle9}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 9)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage9 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage9
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_9 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_9}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -10 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleTen"
                              label="Screenshot Title 10"
                              onChange={(e) => handlePreviewTitle(e, 10)}
                              value={values.previewTitle10}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 10)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage10 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage10
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_10 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_10}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -11 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleEleven"
                              label="Screenshot Title 11"
                              onChange={(e) => handlePreviewTitle(e, 11)}
                              value={values.previewTitle11}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 11)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage11 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage11
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_11 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_11}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                    {/* secreenshot -12 */}
                    <Grid container spacing={1} sx={{ mt: 1 }}>
                      <Grid item xs={6} md={6}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="screenShotTitleTwelve"
                              label="Screenshot Title 12"
                              onChange={(e) => handlePreviewTitle(e, 12)}
                              value={values.previewTitle12}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={3} md={3}>
                        <Card sx={{ p: 2 }}>
                          <Stack spacing={3}>
                            <Button variant="contained" component="label">
                              Upload File
                              <input
                                type="file"
                                hidden
                                onChange={(e) => handlePreviewImage(e, 12)}
                              />
                            </Button>
                          </Stack>
                        </Card>
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <Card sx={{ p: 2 }}>
                          <Stack sx={{ minHeight: 35 }}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              justifyItems="center"
                            >
                              {values.previewImage12 !== null && (
                                <img
                                  src={URL.createObjectURL(
                                    values.previewImage12
                                  )}
                                  width="50%"
                                  alt=""
                                />
                              )}
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                      {location?.state?.row?.preview_image_12 && (
                        <Grid item xs={1} md={1}>
                          <Card sx={{ p: 2 }}>
                            <Stack sx={{ maxHeight: 35 }}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                justifyItems="center"
                              >
                                <Tooltip title="Preview Stored Image">
                                  <IconButton>
                                    <a
                                      href={`${baseUrl}/storage/${location?.state?.row?.preview_image_12}`}
                                      target="_blank" rel="noreferrer"
                                    >
                                      <InfoIcon />
                                    </a>
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      )}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChangeAccordian("panel5")}
                >
                  <AccordionSummary
                    aria-controls="panel3d-content"
                    id="panel3d-header"
                  >
                    <Typography>#5 File Url, Preview Url, Gif File</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={12}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="fileUrl"
                              label="File URL"
                              onChange={(e) =>
                                setValue("fileUrl", e.target.value)
                              }
                              value={values.fileUrl}
                            />
                            <TextField
                              name="previewUrl"
                              label="Preview URL"
                              onChange={(e) =>
                                setValue("previewUrl", e.target.value)
                              }
                              value={values.previewUrl}
                            />

                            <TextField
                              type="file"
                              name="gifFile"
                              onChange={(e) =>
                                setValue("gifFile", e.target.files[0])
                              }
                            />

                            {location?.state?.row?.gif_file && (
                              <a
                                href={`${baseUrl}/storage/${location?.state?.row?.gif_file}`}
                                target="_blank" rel="noreferrer"
                              >
                                <Button>Preview Gif</Button>
                              </a>
                            )}
                          </Stack>
                        </Card>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel6"}
                  onChange={handleChangeAccordian("panel6")}
                >
                  <AccordionSummary
                    aria-controls="panel3d-content"
                    id="panel3d-header"
                  >
                    <Typography>#6 Author & Backlink</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={12}>
                        <Card sx={{ p: 1 }}>
                          <Stack spacing={3}>
                            <TextField
                              name="authorName"
                              label="Author Name"
                              onChange={(e) =>
                                setValue("authorName", e.target.value)
                              }
                              value={values.authorName}
                            />
                            <TextField
                              name="authorUrl"
                              label="Author URL"
                              onChange={(e) =>
                                setValue("authorUrl", e.target.value)
                              }
                              value={values.authorUrl}
                            />
                            <TextField
                              name="other"
                              label="Backlink"
                              onChange={(e) =>
                                setValue("other", e.target.value)
                              }
                              value={values.other}
                            />
                          </Stack>
                        </Card>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Stack>

              <Box
                display="flex"
                justifyContent="center"
                justifyItems="center"
                sx={{ mt: 3 }}
              >
                <Button variant="contained" onClick={(e) => handleStorePost()}>
                  {location?.state != null ? "Update" : "Create"}
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <ToastContainer />
    </>
  );
}
